/*
 * Web api settings
 */

export const feedAPIurls = {
    posts: '/api/ArticlesAboutProducts/GetArticles',
    postsInCategory: '/api/ArticlesAboutProducts/GetArticlesForGivenCategory',
    filters: '/api/ArticlesAboutProducts/GetArticlesCategories',
};

export const sortingOptions = {
    latest: 'desc',
    earliest: 'asc',
};

export const postCount = {
    delta: 4,
    noFilters: 4,
    starting: 8,
};